export const MESSAGES = {
  APP_TITLE: 'Aplicatie semnatura digitala',
  OPEN_DESKTOP_APP: 'In acest moment procesul de semnare a inceput. Asigura-te ca aplicatia Sign Digital Cert este deschisa',
  DESKTOP_APP_WARNING: 'Aplicatia Sign Digital Cert nu pare a fi deschisa. Verificati si daca este cazul porniti aplicatia!',
  DOCUMENT: 'Document:',
  SAVE_DOCUMENT: 'Descarca documentul ce urmeaza a fi semnat',
  BEGIN_SIGNING: 'Incepe semnarea',
  SELECT_CERTIFICATE: 'Selectați certificatul',
  INSERT_PASSWORD: 'Introduceți parola',
  SIGN_DOCUMENT: 'Semnează documentul',
  BROWSER_PROBLEM: 'Browserul dvs. nu suportă redarea video.',
  SELECT_PAGE: 'Alege pagina în care dorești ca semnătura să fie aplicată. Crează locul semnăturii tragând de săgeata mouse-ului către dreapta urmând exemplul de mai jos:'
};
